<template>
  <div class="content-block">
    <div class="content-block-title">{{ $lang.messages.premium_page.title }}</div>
    <div class="table-flex">
      <div class="table-flex-row -main">
        <div class="table-flex-col">
          {{ $lang.messages.premium_page.description}}
        </div>
        <div class="table-flex-col flex -premium">
          <span class="premium-currency">$</span><span class="premium-value">2.</span><span class="premium-cents">99</span>
          <span class="premium-forever">{{ $lang.messages.get_premium_modal.monthly }}</span>
          <button v-if="!isPremium" class="btn btn-premium"  @click.stop="getPremium">{{ $lang.messages.get_premium }}</button>
        </div>
      </div>
      <div class="table-flex-row -header">
        <div class="table-flex-col"></div>
        <div class="table-flex-col -free">{{ $lang.messages.premium_page.free }}</div>
        <div class="table-flex-col -premium">{{ $lang.messages.premium_page.premium }}</div>
      </div>
      <div :key="item.id" v-for="item in tableData" :class="{'last-row': item.id === tableData.length }">
        <div class="table-flex-row -title" :class="{'-top': item.id === 1 }">
          <div class="table-flex-col">
            <img :src="imgUrl(item.icon)" alt="icon" class="table-flex-icon">
            {{ item.title }}
          </div>
          <div class="table-flex-col -free"></div>
          <div class="table-flex-col -premium"></div>
        </div>
        <div :key="feature.id" v-for="feature in item.features" class="table-flex-row">
          <div class="table-flex-col">{{ feature.name }}</div>
          <div class="table-flex-col -free"><i v-if="feature.free" class="icon-check"></i></div>
          <div class="table-flex-col -premium"><i v-if="feature.premium" class="icon-check"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";

const images = require.context('../assets/img/icons/', false, /\.svg$/)
export default {
  name: 'Premium',
  props: ['isPremium'],
  data: function () {
    return  {
      tableData : [
        {
          id: 1,
          title: this.$lang.messages.premium_page.features.settings,
          icon: 'icon-cog.svg',
          features: [
            {
              id: 1,
              name: this.$lang.messages.premium_page.features.settings_additional.lock_when_start,
              free: true,
              premium: true
            },
            {
              id: 2,
              name: this.$lang.messages.premium_page.features.settings_additional.auto_lock,
              free: false,
              premium: true
            },
            {
              id: 3,
              name: this.$lang.messages.premium_page.features.settings_additional.remote_lock,
              free: false,
              premium: true
            },
            {
              id: 4,
              name: this.$lang.messages.premium_page.features.settings_additional.always_top,
              free: false,
              premium: true
            },
            {
              id: 5,
              name: this.$lang.messages.premium_page.features.settings_additional.time_limit,
              free: false,
              premium: true
            },
            {
              id: 6,
              name: this.$lang.messages.premium_page.features.settings_additional.screen_time,
              free: false,
              premium: true
            },
          ]
        },
        {
          id: 2,
          title: this.$lang.messages.premium_page.features.themes,
          icon: 'icon-themes.svg',
          features: [
            {
              id: 1,
              name: this.$lang.messages.premium_page.features.themes_additional.some_theme,
              free: true,
              premium: true
            },
            {
              id: 2,
              name: this.$lang.messages.premium_page.features.themes_additional.animated_themes,
              free: false,
              premium: true
            },
            {
              id: 3,
              name: this.$lang.messages.premium_page.features.themes_additional.upload_bg,
              free: false,
              premium: true
            }
          ]
        },
        {
          id: 3,
          title: this.$lang.messages.premium_page.features.statistic,
          icon: 'icon-statistic.svg',
          features: [
            {
              id: 4,
              name: this.$lang.messages.premium_page.features.statistic_additional.configurate_date_range,
              free: false,
              premium: true
            },
          ]
        },
        {
          id: 4,
          title: this.$lang.messages.premium_page.features.remote_features,
          icon: 'icon-remote.svg',
          features: [
            {
              id: 1,
              name: this.$lang.messages.premium_page.features.remote_features_additional.access_dashboard_from_web,
              free: false,
              premium: true
            },
            {
              id: 2,
              name: this.$lang.messages.premium_page.features.remote_features_additional.get_add_time_remotely,
              free: false,
              premium: true
            },
            {
              id: 3,
              name: this.$lang.messages.premium_page.features.remote_features_additional.check_stat,
              free: false,
              premium: true
            }
          ]
        },
        {
          id: 5,
          title: this.$lang.messages.premium_page.features.sites,
          icon: 'icon-sites.svg',
          features: [
            {
              id: 1,
              name: this.$lang.messages.premium_page.features.sites_additional.add_links_allow,
              free: true,
              premium: true
            },
            {
              id: 2,
              name: this.$lang.messages.premium_page.features.sites_additional.allow_kid_request,
              free: true,
              premium: true
            }
          ]
        },
      ]

    }
  },
  methods: {
    imgUrl: function (path) {
      return images('./' + path)
    },
    updateSettings(keyName, value){
      this.$emit('updatesettings', {[keyName]: value})
    },
    getPremium () {
      if (router.currentRoute.path !== '/premium'){
        this.$emit('showpremiummodal')
      } else {
        window.open('https://kidsmode.browserlock.net/app/#/login/', '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/helpers";
  .table-flex {
    .last-row .table-flex-row:last-child {
      .table-flex-col.-premium {
        border-bottom: 3px solid #7D6AED;
      }
    }

    &-row {
      display: flex;
      padding-left: 76px;
      background: #F5F7FB;

      @include responsive-below($xs){
        padding-left: 40px;
      }

      &:last-child .table-flex-col {
        border-bottom: 0;
      }
      
      &.-title {
        background: #E0E1EF;

        .table-flex-col {
          padding: 24px 0;
          font-weight: 700;
          border-bottom: 0;
          background: #E0E1EF;
          position: relative;
        }
      }

      &.-top {
        border-radius: 30px 0 0 0;
      }

      &.-main {
        padding: 35px;
        background: #F5F7FB;
        border-radius: 20px 20px 0 0;
        position: relative;

        @include responsive-below($md){
          flex-direction: column;
          align-items: center;
        }

        @include responsive-below($xs){
          padding: 20px;
        }

        &:before {
          content: "";
          display: block;
          width: 100%;
          height: 100px;
          background: #F5F7FB;
          position: absolute;
          left: 0;
          top: 100%;
          z-index: -1;
        }

        .table-flex-col {
          background: #F5F7FB;
          font-weight: 700;
          font-size: 20px;
          border: 0;

          &.-premium {
            margin-left: auto;

            @include responsive-below($md){
              margin-left: 0;
            }
          }
        }
        
        .btn-premium {
          color: #5A4A99;
          padding: 14px 38px;
          font-size: 22px;

          @include responsive-below($md){
            font-size: 19px;
            padding: 10px 20px;
          }

          @include responsive-below($xs){
            padding: 10px;
          }
        }
      }
      
      &.-header {

        .table-flex-col {
          font-size: 20px;
          font-weight: 800;
          text-transform: uppercase;
          border-radius: 48px 48px 0px 0px;
          border-bottom: 0;

          @include responsive-below($md){
            font-size: 16px;
            border-radius: 30px 30px 0 0;
          }

          @include responsive-below($xs){
            font-size: 12px;
          }
          
          &.-free {
            color: #828282;
            background: #EAEBF7;
          }

          &.-premium {
            color: #fff;
            background: #7D6AED;
          }
        }
      }
    }

    &-col {
      flex: 0 0 30%;
      background: #F5F7FB;
      font-size: 16px;
      text-align: center;
      border-bottom: 1px solid #D5D5D5;
      padding: 14px 0;
      font-weight: 600;

      @include responsive-below($md){
        flex-basis: 25%;
      }

      &:first-child {
        text-align: left;
        flex-basis: 40%;

        @include responsive-below($md){
          flex-basis: 50%;
        }
      }

      &.-free {
        color: #828282;
      }
      
      &.-premium {
        background: #F1EFFC;
        border-left: 3px solid #7D6AED;
        border-right: 3px solid #7D6AED;
        color: #7D6AED;
      }
    }

    &-icon {
      position: absolute;
      left: -46px;
      width: 26px;
      top: 50%;
      transform: translateY(-50%);

      @include responsive-below($xs){
        left: -33px;
        transform: translateY(-50%) scale(0.8);
      }
    }
  }
  .premium {
    &-currency {
      font-size: 29px;
      color: #806DEF;
    }

    &-value {
      font-size: 39px;
      color: #806DEF;

      @include responsive-below($xs){
        font-size: 30px;
      }
    }

    &-cents {
      font-size: 23px;
      vertical-align: 10px;
      color: #806DEF;
    }

    &-forever {
      color: #806DEF;
      display: inline-block;
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 700;
      padding: 15px;
      position: relative;
      transform-origin: 0 0;
      transform: rotate(-14deg) translate(-30px, 6px);

      @include responsive-below($xs){
        font-size: 10px;
      }

      &:before,
      &:after {
        content: "";
        width: 40%;
        height: 100%;
        display: block;
        background: url("../assets/img/forever-bg.svg") no-repeat left bottom;
        position: absolute;
        left: 0;
        bottom: 0;
        transform: rotate(12deg);
      }

      &:after {
        left: auto;
        right: 0;
        top: 0;
        bottom: auto;
        transform: rotate(192deg);
      }
    }
  }


</style>

